module.exports = __webpack_public_path__ + "static/recursiveDataType-5679f9960d8754d629a26de18aeb90b6.png";